import DisconnectIcon from "@/assets/common/ic_disconnect.svg";

interface WebSocketErrorProps {
  onRetry: () => void;
}

const WebSocketError = ({ onRetry }: WebSocketErrorProps) => {
  return (
    <div className="flex flex-col items-center justify-center bg-#F2F3F5/88 h-full">
      <img src={DisconnectIcon} className="w-20 h-20 mt-4"/>
      <div className="lh-5 text-3.5 text-#626773">服务异常，内容获取失败</div>
      <div className="w-26 h-10 rd-2 bg-#293143 flex items-center justify-center text-#ffffff mt-4 text-3.5" onClick={onRetry}>重试</div>
      <div className='h-34'></div>
    </div>
  );
};

export default WebSocketError;
